import BaseLayout from "@/layout/BaseLayout.vue";
import Layout1 from '@/pages/ArticoloPartecipante.vue' //Partecipanti
import Layout15 from '@/pages/ListaPartecipanti.vue' //Partecipanti

export default [{
   path: '/partecipanti',
   name: "Partecipanti",               
   component: BaseLayout,     
   meta:{
      layout: Layout15,
      params:true,
      tipologia: 'PartecipantePublished',
      breadcrumb:{
        label:  "Partecipanti", 
        parent: 'Home'
      } 
   },
   children: [{
      path: ':slug',      
      name: 'articolo-partecipanti',      
      meta:{  
         layout: Layout1,       
         params:true,
         props: true,
         breadcrumb() {
            const label = this.$route.params.title && !this.$route.params._slug ? this.$route.params.title : this.$route.params.slug;
            return {
               label: label.replaceAll('-', ' ')
            };
         }    
      }
   }],                               
}];
